import React from 'react';
import AlertBar from '../common/AlertBar';

const BrowserSupportAlert = () => (
  <AlertBar alertType="warning">
    Your browser is currently not yet fully supported. We recommend using Chrome on a desktop computer for a better experience.
  </AlertBar>
);

export default BrowserSupportAlert;



// WEBPACK FOOTER //
// ./src/components/Alerts/BrowserSupportAlert.js